import API from "./baseApi";

const getAllCommercials = (payload) => {
  return API.post("/commercials/getAll", payload);
};

const createCommercials = (payload) => {
  return API.post("/commercials", payload);
};

const updateCommercials = (id, payload) => {
  return API.put(`/commercials/${id}`, payload);
};

export default {
  getAllCommercials,
  createCommercials,
  updateCommercials,
};
